import styled from '@emotion/styled'
import { spacer } from 'stylist'

const FormLinks = styled.div`
  display: flex;
  justify-content: center;

  > :not(:last-child) {
    margin-right: ${spacer(3)};
  }

  @supports (display: grid) {
    display: grid;
    grid-gap: ${spacer(3)};
    grid-auto-flow: column;
    justify-content: center;

    > :not(:last-child) {
      margin-right: 0;
    }
  }
`

export default FormLinks



// WEBPACK FOOTER //
// ./src/components/FormLinks.js